export const CUSTOMERS_ACTIONS = {
    LOADING : "loading",
    ERROR: "error",
    CUSTOMERSLIST: "customers_list",
    ADDCUSTOMER:'add_customer',
    EDITCUSTOMER:'edit_customer',
    SELECTEDCUSTOMER:'selected_customer',
    SELECTEDVIEW:'selected_view',
    SEARCHCUSTOMER:'search_customer',
    LIST_FILTERS: 'list_filters',
}
